import { LdtOrderDetailView } from '@ldt/api/order_repository';
import { AuthenticationService } from 'src/api/authentication_service';
import { getApp } from 'src/config/environment';
import { getWorkflowTypeForOrganization } from 'src/distribution_platforms/features/workflows';
import { WorkflowType } from 'src/types/workflows';
import { isLabTech } from 'src/utils';

/**
 * Resolves the order-detail view for the current user and effective organization.
 * Used by loaders and refetch call sites (not inside the GraphQL client).
 */
export function resolveLdtOrderDetailView(): LdtOrderDetailView {
  const effectiveOrganization =
    AuthenticationService.getInstance().getEffectiveOrganization();
  const workflowType = getWorkflowTypeForOrganization(
    effectiveOrganization,
    getApp(),
  );
  return workflowType === WorkflowType.DIRECT_UPLOAD_LAB && isLabTech()
    ? LdtOrderDetailView.DirectUploadLabTech
    : LdtOrderDetailView.Default;
}
